import * as Common from "../../commons/common"

export class Sheet {
  id: number
  sheet_group_key: number
  nendo: number
  exec_date: string
  grade: number
  kind: number
  name: string
  aggregate_flg: boolean
  curriculum_id: number
  subject_id: number
  subject_name: string
  field_names_completed: boolean
  correct_image_completed: boolean
  field_positions_completed: boolean
  room_id: number
  set_room_name: string
  at_students_count: number
  at_uploaded_count: number
  at_image_completed_count: number
  at_progress_rate: number
  at_cut_job_count: number
  at_pdf_job_count: number
  at_full_count: number
  result_image_published: boolean

  constructor(sheet: any){
    this.id = sheet.id;
    this.sheet_group_key = sheet.sheet_group_key;
    this.nendo = sheet.nendo;
    this.exec_date = sheet.exec_date;
    this.grade = sheet.grade;
    this.kind = sheet.kind;
    this.name = sheet.name;
    this.aggregate_flg = sheet.aggregate_flg;
    this.curriculum_id = sheet.curriculum_id;
    this.subject_id = sheet.subject_id;
    this.subject_name = sheet.subject_name;
    this.field_names_completed = sheet.field_names_completed;
    this.correct_image_completed = sheet.corretct_image_completed;
    this.field_positions_completed = sheet.field_positions_completed;
    this.room_id = sheet.room_id;
    this.set_room_name = sheet.set_room_name;
    this.at_students_count = sheet.at_students_count;
    this.at_uploaded_count = sheet.at_uploaded_count;
    this.at_image_completed_count = sheet.at_image_completed_count;
    this.at_progress_rate = Math.floor(sheet.at_progress_rate);
    this.at_cut_job_count = sheet.at_cut_job_count;
    this.at_pdf_job_count = sheet.at_pdf_job_count;
    this.at_full_count = sheet.at_full_count;
    this.result_image_published = sheet.result_image_published;
  }
}

export class SheetListCondition{
  sheet_group_key: string = ""
  nendo: string = ""
  month: string = ""
  grade: string = ""
  kind: string = ""
  curriculum_id: string = ""
  aggregate_flg: string = ""
  page: number = 1
  row_count: number =  Common.SheetListRowCount
}

export class RowSpanInfo{
  sheet_id: number
  sheet_group_key: number
  subject_id: number
  count: number

  constructor(sheet_id: number, sheet_group_key: number, subject_id: number, count: number){
    this.sheet_id = sheet_id;
    this.sheet_group_key = sheet_group_key;
    this.subject_id = subject_id;
    this.count = count;
  }
}

export class Room{
  room_id: number
  set_room_name: string

  constructor(room: any){
    this.room_id = room.room_id;
    this.set_room_name = room.set_room_name;
  }
}